// src/PageViewTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function PageViewTracker() {
  const location = useLocation();  // Get the current location (URL)

  useEffect(() => {
    // Check if gtag is available, then track page view dynamically for every route change
    if (window.gtag) {
      window.gtag('config', 'G-FT6G66V0VF', {  // Replace with your UA Tracking ID
        page_path: location.pathname + location.search, // Dynamically track current path
      });
    }
  }, [location]);  // Dependency on location so it triggers when location changes

  return null;  // This component doesn't render anything, it's for tracking
}

export default PageViewTracker;
